module.exports = __webpack_public_path__ + "static/media/noah-wetering.eaf444f6.jpg";